import { useCancelDeleteRequest, useDeleteRequest } from "@/api/expedition.api";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { getExpeditionIdentifier } from "@/lib/expedition.util";
import { GetAllExpeditionResponseDtoExpedition } from "@/types/api/api-types";
import { Loader2 } from "lucide-react";

type Props = {
  expedition: GetAllExpeditionResponseDtoExpedition;
  onClose: () => void;
  open: boolean;
};

export const DeleteModal = ({ expedition, onClose, open }: Props) => {
  const { mutateAsync: deleteRequest, isPending: isDeletionPending } = useDeleteRequest();
  const { mutateAsync: cancelDeleteRequest, isPending: isCancellationPending } =
    useCancelDeleteRequest();

  const isCancelling = Boolean(expedition.deletedRequestAt);
  const isPending = isCancelling ? isCancellationPending : isDeletionPending;
  const expeditionIdentifier = getExpeditionIdentifier(expedition) ?? "";

  const { title, description } = isCancelling
    ? {
        title: "Annuler la demande de suppression",
        description: `Voulez-vous annuler la demande de suppression de l'expédition ${expeditionIdentifier} ?`,
      }
    : {
        title: `Supprimer l'expédition ${expeditionIdentifier}`,
        description: "L’équipe Pelican sera notifiée pour valider la suppression.",
      };

  const handleConfirm = async () => {
    const mutate = isCancelling ? cancelDeleteRequest : deleteRequest;
    await mutate(expedition.id);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      dismissible={!isPending}
      title={title}
      description={description}
      footer={
        <div className="flex w-full gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isPending}
            className="flex-1"
          >
            Annuler
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
            className="flex-1"
          >
            {isPending ? <Loader2 className="animate-spin" /> : "Confirmer"}
          </Button>
        </div>
      }
    />
  );
};
